import { Avatar, Stack } from "@mui/material";
import { useRouter } from "next/router";
import { UseFormSetError } from "react-hook-form";
import toast from "react-hot-toast";
import { useUser } from "@/auth/useUser";
import PageContainer from "@/components/common/pageContainer/pageContainer";
import PageHeader, {
  PageHeaderButton,
} from "@/components/common/pageHeader/pageHeader";
import ClientForm from "@/components/serviceFlow/clientDetails/forms/clientForm";
import { UpdateClientMutationVariables } from "@/graphql/mutations/clients.graphql.types";
import { FormValidationError } from "@/types";
import { useUpdateClientFormData } from "./useUpdateClientFormData";

export const addGraphQLError = ({
  error,
  message,
  setError,
  alternativeMessage,
  toastId,
}: {
  error: FormValidationError;
  message: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setError: UseFormSetError<any>;
  alternativeMessage: string;
  toastId: string;
}) => {
  let toastMessage = alternativeMessage;
  if (
    error === FormValidationError.CONSTRAINT_VIOLATION &&
    message.includes("unique_client_per_medspa")
  ) {
    setError("email", { type: "custom", message: "Email already exists" });
    toastMessage = "Email already exists";
  }
  toast.error(toastMessage, { id: toastId });
};

function EditClientView() {
  const { medspa } = useUser();
  const {
    query: { slug },
    push,
  } = useRouter();
  const { control, setValue, trigger, handleSubmit, onSubmit, loading } =
    useUpdateClientFormData(() => {
      push(`/${medspa}/clients/${slug}`);
    });

  return (
    <PageContainer
      sx={{ height: "auto", background: "#ffffff", overflow: "visible" }}
    >
      <PageHeader
        title="Edit details"
        goBackStrategy="history"
        action={
          <PageHeaderButton onClick={handleSubmit(onSubmit)} disabled={loading}>
            Save
          </PageHeaderButton>
        }
      />
      <Stack
        data-dd-privacy="mask"
        sx={{
          alignItems: "center",
        }}
      >
        <Avatar sx={{ width: 64, height: 64, mb: 4 }} />
        <ClientForm<UpdateClientMutationVariables>
          control={control}
          setValue={setValue}
          trigger={trigger}
        />
      </Stack>
    </PageContainer>
  );
}

export default EditClientView;
